// based on rc-pagination 1.20.14
export { default } from './Pagination';
